import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedService {

    _dataSharedClienteList = new BehaviorSubject<any>(null);
    _dataSharedNaveList = new BehaviorSubject<any>(null);
    _dataSharedLocalList = new BehaviorSubject<any>(null);
    _dataSharedLineaList = new BehaviorSubject<any>(null);
    _dataSharedTipoContenedorList = new BehaviorSubject<any>(null);
    _dataSharedTipoContenedorUserList = new BehaviorSubject<any>(null);

    constructor() {}

    setDataClienteList(data: any) {
        this._dataSharedClienteList.next(data);
    }

    setDataNaveList(data: any) {
        this._dataSharedNaveList.next(data);
    }

    setDataLocalList(data: any) {
        this._dataSharedLocalList.next(data);
    }

    setDataLineaList(data: any) {
        this._dataSharedLineaList.next(data);
    }

    setDataTipoContenedorList(data: any) {
        this._dataSharedTipoContenedorList.next(data);
    }

    setDataTipoContenedorUserList(data: any) {
        this._dataSharedTipoContenedorUserList.next(data);
    }
}
